<template>
  <v-container>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="70%" :retain-focus="false">
      <v-skeleton-loader v-if="loading" type="article, actions" />
      <v-card v-if="!loading">
        <!-- Título sin divider arriba -->
        <v-card-title class="pl-5 pt-5 pb-0">
          <v-col cols="12">
            <span style="font-size: 20px;">
              {{ $t("wkt.admin.release.view-release.title") }}
            </span>
          </v-col>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container @wheel="onWheel">
            <v-row
              v-for="(release, index) in data"
              :key="release.id"
              class="py-2"
            >
              <v-col cols="12" style="padding-bottom: 0">
                <span style="color: #185EA9; font-size: 15px;">
                  {{ formatLongDate(release.releaseDate) }}
                </span>
              </v-col>
              <v-col cols="12" style="padding-bottom: 0">
                <h3 style="color: #000000; font-size: 18px; margin: 0;">
                  {{ release.title }}
                </h3>
              </v-col>
              <v-col cols="12">
                <span style="color: #424242; font-size: 15px;">
                  {{ release.description }}
                </span>
              </v-col>

              <v-col cols="12" v-if="index < data.length - 1">
                <v-divider class="my-2"></v-divider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showDialog = false"
            style="font-size: 0.9em; font-weight: 400;"
          >
            {{ $t("wkt.admin.common.dialog-buttons.close").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import api from "../../../api/worktime";

export default {
  name: "ReleaseViewerDialog",
  mixins: [BaseModule],
  data() {
    return {
      loading: false,
      showDialog: false,
      data: {},
    };
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    // eslint-disable-next-line no-unused-vars
    onReveal(action, payload) {
      this.showDialog = true;
      this.loading = true;
      api.getReleases(
        (res) => {
          this.data = res;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    formatLongDate(dateObj) {
      if (!dateObj || !dateObj.day || !dateObj.month || !dateObj.year) {
        return "";
      }
      const date = new Date(dateObj.year, dateObj.month - 1, dateObj.day);
      return date.toLocaleDateString(
        [this.$i18n.locale, 'en'], 
        { year: 'numeric', month: '2-digit', day: '2-digit' }
      );
    },
  }
};
</script>
